import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  FormControlLabel,
  FormHelperText,
  FormControl,
  Switch
} from "@material-ui/core";
import Delta from "mdi-material-ui/Delta";

import {
  RULE_FORM_FIELD_LABELS,
  FEED_EXCLUSION_OPTIONS
} from "utils/constants";
import MultiSelect from "./MultiSelect";
import { LabelWithIcon } from "./LabelWithIcon";

const styles = theme => ({
  expansionDetails: {
    flexDirection: "column"
  }
});

class ForgeRuleFormItem extends React.Component {
  render() {
    const { ruleStore, classes, type, label, errorField } = this.props;

    return (
      <Accordion expanded={ruleStore.notifications[type].enabled}>
        <AccordionSummary>
          <FormControlLabel
            value={type}
            control={
              <Switch
                checked={ruleStore.notifications[type].enabled}
                onChange={(e, checked) =>
                  ruleStore.setNotificationEnabled(type, checked)
                }
              />
            }
            label={<LabelWithIcon icon={<Delta />} label={label} />}
          />
        </AccordionSummary>
        <AccordionDetails className={classes.expansionDetails}>
          <TextField
            id={type}
            label="Tags"
            InputLabelProps={{
              shrink: true
            }}
            placeholder="csv list of tags"
            fullWidth
            value={ruleStore.notifications[type].destination}
            error={errorField}
            onChange={e =>
              ruleStore.setNotificationDestination(type, e.target.value)
            }
            margin="normal"
          />
          {errorField ? (
            <FormHelperText error>Tags can not be blank.</FormHelperText>
          ) : null}
          <FormControlLabel
            control={
              <Switch
                checked={ruleStore.isTrue(
                  ruleStore.notifications[type].destinationOptions
                    .ENABLE_PUSH_NOTIFICATIONS
                )}
                onChange={(e, checked) =>
                  ruleStore.setPushNotifications(type, checked)
                }
              />
            }
            label="Send push notification to At Bat"
          />
          <FormControlLabel
            control={
              <Switch
                checked={ruleStore.isTrue(
                  ruleStore.notifications[type].destinationOptions
                    .OMIT_DESCRIPTION
                )}
                onChange={(e, checked) =>
                  ruleStore.setOmitDescription(type, checked)
                }
              />
            }
            label="Omit Forge Description"
          />
          <FormControl component="fieldset" margin="normal" fullWidth>
            <MultiSelect
              id={"multi-select-auto-publish-exclusions-" + type}
              label={RULE_FORM_FIELD_LABELS.AUTO_PUBLISH_EXCLUSIONS}
              values={ruleStore.autoPublishExclusionsWithLabels(type)}
              options={FEED_EXCLUSION_OPTIONS}
              onChange={selectedItems =>
                ruleStore.setAutoPublishExclusions(type, selectedItems)
              }
            />
          </FormControl>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default inject("ruleStore")(
  withStyles(styles)(observer(ForgeRuleFormItem))
);



// WEBPACK FOOTER //
// ./src/components/ForgeRuleFormItem.js